module.exports = __webpack_public_path__ + "static/media/MHRP09N0012.e6a74ee5.svg";